<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="2rem">
  <img *ngIf="completed"src="assets/check.png" alt="check">
  <img *ngIf="!completed" src="assets/check_false.png" alt="check_false">
  <p *ngIf="!secretTask" class="t-text">{{task}}</p>
  <p *ngIf="secretTask" class="t-text-secret">{{task}}</p>
</div>
